import GetIcon from "../utils/Icon";
import {
  useGetDeleteUploadFileMutation,
  useGetDocOfAttachmentQuery,
  usePostUploadFileMutation,
} from "../store/api/globalapi";
import { useState, useEffect } from "react";

const Attachment = ({ doctype, docname, readOnly = false }) => {
  const [attachments, setAttachments] = useState([]);
  const [UploadFileApi] = usePostUploadFileMutation();
  const [triggerDelete] = useGetDeleteUploadFileMutation();
  const { data: attachmentData, refetch } = useGetDocOfAttachmentQuery({
    doctype,
    docname,
  });

  // 🔄 Whenever new data comes from API, sync to local state
  useEffect(() => {
    if (attachmentData?.data && Array.isArray(attachmentData.data)) {
      setAttachments(attachmentData.data);
    }
  }, [attachmentData]);

  // 📤 File Upload
  const handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    const originalExt = selectedFile.name.split(".").pop();
    const newFileName = `${docname}_${Date.now()}.${originalExt}`;
    const renamedFile = new File([selectedFile], newFileName, {
      type: selectedFile.type,
    });

    const formData = new FormData();
    formData.append("file", renamedFile);
    formData.append("doctype", doctype);
    formData.append("docname", docname);

    try {
      const response = await UploadFileApi(formData).unwrap();
      const fileData = response?.message;

      if (fileData?.file_url && fileData?.name) {
        refetch();
      } else {
        console.error("Unexpected API response:", response);
        alert("Upload failed: Required file data not found.");
      }
    } catch (err) {
      console.error("Upload error:", err);
      alert("Upload failed due to a network/server error.");
    }
  };

  // ❌ File Delete
 const handleDelete = async (fid) => {
  if (!window.confirm("Are you sure you want to delete this file?")) return;

  try {
    const response = await triggerDelete({
      fid,
      dt: doctype,
      dn: docname,
    }).unwrap();

    console.log("Delete success:", response);

    // remove from UI immediately
    setAttachments((prev) => prev.filter((file) => file.name !== fid));
  } catch (err) {
    console.error("Failed to delete file:", err);
    alert("Delete failed. Check console for error.");
  }
};

  return (
    <div
      className="d-flex align-items-center mb-1 mt-1 px-3"
      style={{ gap: "12px", fontSize: "12px", flexWrap: "wrap" }}
    >
      <div
        className="file-manager-wrapper"
        style={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "8px",
        }}
      >
        {/* ✅ Attachment List */}
        {attachments.length > 0 &&
          attachments.map((file, index) => {
            const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(file.file_name);
            const fullUrl = `${process.env.REACT_APP_API_URL}${
              file.file_url?.startsWith("/") ? "" : "/"
            }${file.file_url}`;

            return (
              <div
                key={file.name || index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#FFF1D6",
                  padding: "6px 10px",
                  borderRadius: "8px",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                  maxWidth: "250px",
                }}
              >
                <a
                  href={fullUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: "none",
                    color: "#1E1E1E",
                    fontSize: "12px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: isImage ? "140px" : "180px",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                  title={file.file_name}
                >
                  📄 {file.file_name?.slice(0, 10)}
                </a>

                {!readOnly && (
                  <button
                    onClick={() => handleDelete(file.name)}
                    style={{
                      background: "transparent",
                      border: "none",
                      color: "#EF4444",
                      cursor: "pointer",
                      fontSize: "10px",
                      marginLeft: "4px",
                    }}
                    title="Delete file"
                  >
                    ❌
                  </button>
                )}
              </div>
            );
          })}

        {/* 📎 Upload Section */}
        {readOnly ? (
          <div style={{ cursor: "not-allowed" }}>
            <span style={{ position: "relative", top: "-1px" }}>
              <GetIcon iconName="CgAttachment" size={12} />
            </span>
            <span
              className="fw-semibold"
              style={{ color: "#4B002B", cursor: "not-allowed" }}
            >
              Attachments
            </span>
          </div>
        ) : (
          <label htmlFor="attachmentfile" style={{ cursor: "pointer" }}>
            <span style={{ position: "relative", top: "-1px" }}>
              <GetIcon iconName="CgAttachment" size={12} />
            </span>
            <span
              className="fw-semibold"
              style={{ color: "#4B002B", cursor: "pointer" }}
            >
              Attachments
            </span>
          </label>
        )}

        <input
          hidden
          id="attachmentfile"
          type="file"
          onChange={readOnly ? undefined : handleFileChange}
          readOnly={readOnly}
        />
      </div>
    </div>
  );
};

export default Attachment;
